
import { CartAddEvent } from '@theme/events';

export class AddonItem extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll(`.addon-item__selector [data-input-variant-id]`).forEach(ele => {
      ele.addEventListener('change', function(event) {
        const addonItem = this.closest('addon-item');
        const addonVariantId = event.target.value;
        const addonProuctJSON = JSON.parse( addonItem.querySelector(`[data-addon-product-json]`).innerHTML );

        let addonVariant = false
        for( let i=0 ; i<addonProuctJSON.variants.length ; i++ ) {
          if( addonProuctJSON.variants[i].id == addonVariantId ) {
            addonVariant = addonProuctJSON.variants[i]
            break
          }
        }

        // console.log({
        //   'event': event,
        //   'addonItem': addonItem,
        //   'addonVariantId': addonVariantId,
        //   'addonProuctJSON': addonProuctJSON,
        //   'addonVariant': addonVariant,
        // })

        if( !addonVariant ) {
          return
        }

        if( addonVariant.featured_image ) {
          addonItem.querySelector(`.addon-item__image img`).removeAttribute('srcset');
          addonItem.querySelector(`.addon-item__image img`).setAttribute('src', addonVariant.featured_image.src.replace(`.png`, `_600x.png`).replace(`.jpg`, `_600x.jpg`))
        }
        addonItem.querySelector(`.addon-item__price`).innerHTML = `$${(addonVariant.price/100)}`
        addonItem.querySelector(`.addon-item__compare-at-price`).innerHTML = (addonVariant.compare_at_price ? `$${(addonVariant.compare_at_price / 100)}` : '')

        if( addonItem.querySelector(`.addon-item__variant-title`) ) {
          addonItem.querySelector(`.addon-item__variant-title`).innerHTML = addonVariant.title
        }
        return;
      })
    })

    this.querySelectorAll(`[type="submit"]`).forEach(button => {
      button.addEventListener('click', function(event) {
        event.preventDefault()
        const addonItem = this.closest('addon-item');
        addonItem.classList.add( 'loading' )

        addonItem.querySelectorAll('[data-input-variant-id]').forEach(ele=>{
          ele.setAttribute('name', 'id');
        })

        let addToCartForm = addonItem.querySelector('form[action$="/cart/add"]');
        let formData = new FormData(addToCartForm);
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => {
          addonItem.classList.remove('loading');
          // https://community.shopify.com/c/technical-q-a/run-function-every-time-cart-js-is-updated/td-p/1717424
          fetch(`${Shopify.routes.root}cart.js`)
            .then((res) => {
              return res.json();
            })
            .then((data) => {
              this.dispatchEvent(
                new CartAddEvent({}, this.id, {
                  didError: true,
                  source: 'product-form-component',
                  itemCount: 1,
                  productId: addonItem.dataset.productId
                })
              );
            })
        addonItem.querySelectorAll('[data-input-variant-id]').forEach(ele=>{
          ele.removeAttribute('name');
        })
          return response.json()
        })
        .catch((error) => {
          addonItem.classList.remove('loading')
          console.error('Error:', error)
        })
      })
    })
  }

  disconnectedCallback() {
  }
}

if (!customElements.get('addon-item')) {
  customElements.define('addon-item', AddonItem);
}
